import { render, staticRenderFns } from "./wonderful.vue?vue&type=template&id=09247c18&scoped=true"
import script from "./wonderful.vue?vue&type=script&lang=js"
export * from "./wonderful.vue?vue&type=script&lang=js"
import style0 from "./wonderful.vue?vue&type=style&index=0&id=09247c18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09247c18",
  null
  
)

export default component.exports